var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { spacing } from "../../foundations/spacing";
import { Link as RouterLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { fontFamily } from "../../foundations/typography";

var getColor = function getColor(colors, state, variant, wasVisited) {
  if (wasVisited) {
    return colors.linkVisited;
  }

  var linkColors = {
    primary: {
      "default": colors.linkDefault,
      active: colors.linkActive
    },
    secondary: {
      "default": colors.onSurfaceHigh,
      active: colors.onSurfaceLow
    }
  };
  return linkColors[variant][state];
};

export var linkStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-style: normal;\n  text-align: ", ";\n  border: none;\n  background: none;\n  text-decoration: none;\n  transition: all 0.2s, font-size 0s;\n  position: relative;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n    transform: initial;\n  }\n\n  &:focus {\n    outline: ", " auto;\n  }\n\n  &:active {\n    color: ", ";\n  }\n\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  font-size: ", ";\n  font-weight: 700;\n  letter-spacing: 1px;\n  line-height: ", ";\n  color: ", ";\n  border-radius: ", ";\n  min-height: 30px;\n  padding: 1px;\n\n  svg {\n    margin-left: ", ";\n  }\n"])), fontFamily, function (props) {
  return props.textAlign;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primaryFocus;
}, function (_ref2) {
  var theme = _ref2.theme,
      variant = _ref2.variant,
      $wasVisited = _ref2.$wasVisited;
  return getColor(theme.colors, 'active', variant, $wasVisited);
}, spacing.size05, spacing.size06, function (_ref3) {
  var theme = _ref3.theme,
      variant = _ref3.variant,
      $wasVisited = _ref3.$wasVisited;
  return getColor(theme.colors, 'default', variant, $wasVisited);
}, spacing.size01, spacing.size02);
export var StyledLink = styled.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n"])), linkStyles);
export var StyledRouterLink = styled(RouterLink)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), linkStyles);